module.exports = __webpack_public_path__ + "assets/sushi_mobile-4fdf8b.svg";